import {
  generatePatternByGarment,
  getDefaultMeasurementsByGarment,
  getGarmentConfig as resolveGarmentConfig,
  getGarmentRoadmap as resolveGarmentRoadmap,
  resolveGeometryVersionByGarment,
  resolveFormulaVersionByGarment,
  getSupportedGeometryVersionsByGarment,
} from '@/lib/patterns/registry';

export function generatePattern(measurements, controls = {}, garmentType = 'trouser') {
  return generatePatternByGarment(garmentType, measurements, controls);
}

export function getDefaultMeasurements(garmentType = 'trouser') {
  return getDefaultMeasurementsByGarment(garmentType);
}

export function getGarmentConfig(garmentType = 'trouser') {
  return resolveGarmentConfig(garmentType);
}

export function getGarmentRoadmap() {
  return resolveGarmentRoadmap();
}

export function resolveGeometryVersion(garmentType = 'trouser', patternLike = {}) {
  return resolveGeometryVersionByGarment(garmentType, patternLike);
}

export function resolveFormulaVersion(garmentType = 'trouser', patternLike = {}) {
  return resolveFormulaVersionByGarment(garmentType, patternLike);
}

export function getSupportedGeometryVersions(garmentType = 'trouser') {
  return getSupportedGeometryVersionsByGarment(garmentType);
}
